module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Prices","code":"Stock Code","description":"Description","category":"Category","price":"Price","unit":"Unit"},"es":{"title":"Precios","code":"Número de inventario","description":"Descripción","category":"Categoría","price":"Precio","unit":"Unidad"},"sw":{"title":"Bei","code":"Nambari ya Hisa","description":"Maelezo","category":"Jamii","price":"Bei","unit":"Kitengo"}}')
  delete Component.options._Ctor
}
